import React from "react";
import styled from "styled-components";

function InvalidChat() {
  return (
    <Container>
      <Logo src={`${process.env.PUBLIC_URL}/assets/images/logo_pegamento_text.jpg`} />
      <p>
        This link has expired, please request a new one.
      </p>
    </Container>
  );
}

export default InvalidChat;

const Container = styled.div`
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  /* margin: 0 auto;
  padding: 100px 0; */

  & > p {
    text-align: center;
    width: 200px;
    margin-top: 10px;
    margin-bottom: 35px;
    font-family: "montserrat";
    font-size: 16px;
    font-weight: 300;
  }

  & > p span {
    color: #00a2c5;
    cursor: pointer;
  }
`;

const Logo = styled.img`
  object-fit: contain; // keep aspect ratio
  height: 60px;
  margin: 20px 0;
`;
